
export interface Lab_Interface {
  id:number,
  device_id:number,
  device_name:String,
  device_code:string,
  device_serial:string,
  recieveLab:string,
  downloadLab:string,
  uploadLab:string,
  code:string,
  src:string,
  customer:string,
  calibration_date:string,
  expert_Calibration:string,
  expertName:string,
  contractor:string,
  certificateNO:String,
  status:number,
  delay:number,
  delay1:number,
  Processing:boolean,
  child:Array<Lab_Interface>
}

export function Empty_Lab_Interface():Lab_Interface{
  return{
    id:0,
    device_id:0,
    delay:0,
    delay1:0,
    device_name:'',
    device_code:'',
    device_serial:'',
    recieveLab:'',
    downloadLab:'',
    uploadLab:'',
    code:'',
    customer:'',
    contractor:'',
    calibration_date:'',
    src:'',
    expert_Calibration:'',
    expertName:'',
    status:0,
    certificateNO:'',
    Processing:false,
    child:[]
  }
}
